import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=a4e628b2&scoped=true"
import script from "./ShipmentForm.vue?vue&type=script&lang=js"
export * from "./ShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentForm.vue?vue&type=style&index=0&id=a4e628b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e628b2",
  null
  
)

export default component.exports